import React from "react";
import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

const DatePicker = ({ label, onChange, value, ...otherProps }) => {
  // console.log(value.toISOString())
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        {...otherProps}
        autoOk
        clearable="true"
        variant="inline"
        format="dd/MM/yyyy"
        margin="normal"
        label={label}
        value={value}
        onChange={(date) => {
          if (!isNaN(date)) {
            onChange(date);
          }
        }}
      />
    </MuiPickersUtilsProvider>
  );
};

export default DatePicker;
